module.exports = __webpack_public_path__ + "static/02-e1a7163cb809e53e63a23376bc0fdbca.png";